import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 20);
  });
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm border-b border-slate-100' : 'bg-transparent'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="flex justify-between items-center h-20" data-id="element-105">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/pKnV3JbaQe8rMACB2pGNu8/pasted-image.png" alt="GO OUT Performance" className="h-10 w-auto" data-id="element-107" />
            <span className={`text-xl font-bold tracking-tight ${isScrolled ? 'text-navy-900' : 'text-navy-900'}`} data-id="element-108">
              GO OUT <span className="text-blue-600" data-id="element-109">Performance</span>
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-110">
            <a href="#servicios" className="text-slate-600 hover:text-blue-600 font-medium transition-colors" data-id="element-111">
              Servicios
            </a>
            <a href="#metodologia" className="text-slate-600 hover:text-blue-600 font-medium transition-colors" data-id="element-112">
              Metodología
            </a>
            <a href="#por-que-nosotros" className="text-slate-600 hover:text-blue-600 font-medium transition-colors" data-id="element-113">
              Por qué nosotros
            </a>
            <a href="https://calendly.com/gooutperformance/30min" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-all shadow-sm hover:shadow-md" data-id="element-114">
              Agendar reunión
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-115">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-900 hover:text-blue-600 p-2" data-id="element-116">
              {isMobileMenuOpen ? <X size={24} data-id="element-117" /> : <Menu size={24} data-id="element-118" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white border-b border-slate-100" data-id="element-119">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-120">
            <a href="#servicios" className="block px-3 py-3 text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-121">
              Servicios
            </a>
            <a href="#metodologia" className="block px-3 py-3 text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-122">
              Metodología
            </a>
            <a href="#por-que-nosotros" className="block px-3 py-3 text-base font-medium text-slate-700 hover:text-blue-600 hover:bg-slate-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-123">
              Por qué nosotros
            </a>
            <div className="pt-4" data-id="element-124">
              <a href="https://calendly.com/gooutperformance/30min" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-lg font-semibold transition-all shadow-sm" data-id="element-125">
                Agendar reunión
              </a>
            </div>
          </div>
        </motion.div>}
    </motion.nav>;
}